import { ModbusReadCoilScheduleEventCommandConfig } from '@thingslog/repositories';
import { EventConfigFactory } from './EventConfigFactory';

export class ModbusReadCoilFactory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ModbusReadCoilScheduleEventCommandConfig {
    return {
      '@type': 'MODBUS_READ_COIL',
      deviceCommand: 'MODBUS',
      modbusCommandTag: '1',
      deviceNumbers,
      sensorIndex: 0,
      slaveDeviceNumber: '',
      numberOfRelaysToRead: 1,
    };
  }
}
